import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { usePostResetPassword } from '../../hooks/react-query/useUserData';
import PasswordChangeForm from './passwordChangeForm';

const ResetPassword = () => {
  const navigate = useNavigate();

  const [serverError, setServerError] = useState();
  const { mutate } = usePostResetPassword();
  const location = useLocation();
  const { pathname } = location;

  const handlePasswordReset = (payload) => {
    const resetCode = pathname.split('/')[2];
    mutate(
      { payload, resetCode },
      {
        onSuccess: (data) => {
          if (data && data.data.status === 'fail') {
            if (data.exceptions && data.exceptions.length) {
              setServerError(data.exceptions[0]);
            }
          } else if (data && data.data.status === 'success') {
            navigate('/');
          }
        },
      }
    );
  };

  return (
    <PasswordChangeForm
      serverError={serverError}
      handleSubmit={handlePasswordReset}
      title={'Αλλαγή Κωδικού'}
      setServerError={setServerError}
      handleClick={() => navigate('/')}
    />
  );
};

export default ResetPassword;
